import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseItem, CardComponent, ItemService, MessageService, MessageComponent } from '@spartacus/organization/administration/components';
import { ViewComponent, PopoverDirective, IconComponent } from '@spartacus/storefront';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';



@Component({
    selector: 'app-efa-org-card',
    templateUrl: './efa-org-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    providers: [MessageService],
    imports: [ViewComponent, PopoverDirective, IconComponent, RouterLink, MessageComponent, RouterOutlet, AsyncPipe, TranslatePipe]
})
export class EfaOrgCardComponent extends CardComponent< BaseItem> implements OnInit {

  constructor(
    protected itemService: ItemService<BaseItem>,
    protected messageService: MessageService
  ) {
    super(itemService, messageService);
   }

  ngOnInit(): void {
  }

}
